import {
    type DeepPartial,
    MoneyMapAccountType,
    type MoneyMapAccountWithAccountDetails,
    type MoneyMapBankAccountDetails,
    type MoneyMapCategory,
    type MoneyMapQuilttAccountDetails,
    type MoneyMapSyncteraExternalAccountDetails,
} from '@fruitful/types';
import {
    FRUITFUL_ICON_KEY,
    FruitfulCustomIcon,
    InstitutionLogo,
} from 'smoothie';

import { MoneyMapCategoryToAccountColorMap } from '../constants';

interface MoneyMapBankAccountIconProps {
    icon: string;
    color?: string;
    useAltColors?: boolean;
}

const MoneyMapBankAccountIcon = ({
    icon,
    color,
    useAltColors = false,
}: MoneyMapBankAccountIconProps) => {
    return (
        <FruitfulCustomIcon
            icon={icon}
            color={color}
            size="xs"
            useAltColors={useAltColors}
        />
    );
};

interface MoneyMapExternalAccountLogoProps {
    logo?: string;
}

const MoneyMapExternalAccountLogo = ({
    logo,
}: MoneyMapExternalAccountLogoProps) => {
    return <InstitutionLogo logo={logo} size="xs" />;
};

interface MoneyMapAccountIconProps {
    category: MoneyMapCategory;
    account: DeepPartial<MoneyMapAccountWithAccountDetails>;
}

export const MoneyMapAccountIcon = ({
    category,
    account,
}: MoneyMapAccountIconProps) => {
    const { type, accountDetails } = account;
    const categoryColor = MoneyMapCategoryToAccountColorMap[category];

    if (
        type === MoneyMapAccountType.INTERNAL_BANKING ||
        type === MoneyMapAccountType.APEX_INVESTMENT_MANAGEMENT
    ) {
        // Use internal set of logos
        const { icon, color } = (accountDetails ??
            {}) as MoneyMapBankAccountDetails;
        return (
            <MoneyMapBankAccountIcon
                icon={icon ?? FRUITFUL_ICON_KEY}
                color={color ?? categoryColor}
                useAltColors={
                    type === MoneyMapAccountType.APEX_INVESTMENT_MANAGEMENT
                }
            />
        );
    }

    // Use external institution logo
    const { logo } = (accountDetails ?? {}) as
        | MoneyMapSyncteraExternalAccountDetails
        | MoneyMapQuilttAccountDetails;
    return <MoneyMapExternalAccountLogo logo={logo} />;
};
